/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Theme({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" clipPath="url(#Theme_svg__a)"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M1 8a7 7 0 0 1 14 0 1.75 1.75 0 0 1-1.75 1.75h-3.245c-1.377 0-2.02 1.707-1.009 2.641C9.996 13.314 9.361 15 8 15a7 7 0 0 1-7-7" /><circle cx={8} cy={4.25} r={0.6} fill="currentColor" strokeWidth={0.5} /><circle cx={4.25} cy={8} r={0.6} fill="currentColor" strokeWidth={0.5} transform="rotate(90 4.25 8)" /><circle cx={10.652} cy={5.348} r={0.6} fill="currentColor" strokeWidth={0.5} transform="rotate(45 10.652 5.348)" /><circle cx={5.348} cy={5.348} r={0.6} fill="currentColor" strokeWidth={0.5} transform="rotate(135 5.348 5.348)" /></g><defs><clipPath id="Theme_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;